import { useInvalidateBrandAccountSurveysQuery } from '~/hooks/useBrandAccountSurveysQuery/useInvalidateBrandAccountSurveysQuery'

import { useCommonQueryCurrentBrandAccount } from '../useCommonQuery'

export const useInvalidateCurrentBrandAccountSurveysQuery = () => {
  const currentBrandAccount = useCommonQueryCurrentBrandAccount()

  return useInvalidateBrandAccountSurveysQuery(currentBrandAccount?.id)
}
